import { Capacitor } from '@capacitor/core';
import { CallKitVoip } from 'capacitor-plugin-callkit-voip';

class CallKitService {
    constructor() {
        this.isInitialized = false;
        this.listeners = [];
    }

    async initialize() {
        if (!Capacitor.isNativePlatform() || Capacitor.getPlatform() !== 'ios') {
            console.log('CallKit is only available on iOS natively.');
            return;
        }
        
        if (this.isInitialized) return;

        try {
            await CallKitVoip.register();
            
            CallKitVoip.addListener('registration', ({ token }) => {
                console.log('CallKit VoIP token:', token);
                localStorage.setItem('voip_token', token);
            });

            CallKitVoip.addListener('callAnswered', ({ callId }) => {
                console.log('Call answered:', callId);
                this._notifyListeners('callAnswered', callId);
            });

            CallKitVoip.addListener('callEnded', ({ callId }) => {
                console.log('Call ended:', callId);
                this._notifyListeners('callEnded', callId);
            });

            this.isInitialized = true;
        } catch (error) {
            console.error('CallKit initialization failed:', error);
        }
    }

    async reportIncomingCall(callId, callerName, hasVideo = false) {
        if (!Capacitor.isNativePlatform() || Capacitor.getPlatform() !== 'ios') return;
        
        try {
            await CallKitVoip.reportIncomingCall({
                callId,
                callerName,
                hasVideo
            });
        } catch (error) {
            console.error('Failed to report incoming call:', error);
        }
    }

    async endCall(callId) {
        if (!Capacitor.isNativePlatform() || Capacitor.getPlatform() !== 'ios') return;
        
        try {
            await CallKitVoip.endCall({ callId });
        } catch (error) {
            console.error('Failed to end call via CallKit:', error);
        }
    }

    on(event, callback) {
        this.listeners.push({ event, callback });
        return () => {
            this.listeners = this.listeners.filter(l => l.callback !== callback);
        };
    }

    _notifyListeners(event, data) {
        this.listeners.forEach(listener => {
            if (listener.event === event) {
                listener.callback(data);
            }
        });
    }
}

export const callKitService = new CallKitService();
